import { render } from "./FooterCompanyLogo.vue?vue&type=template&id=0da024c1"
import script from "./FooterCompanyLogo.vue?vue&type=script&lang=js"
export * from "./FooterCompanyLogo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/jeronimo/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__